import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { Shift } from "../redux/types";
import { useAppDispatch } from "../redux/hooks";
import { loading, shiftsFetched, shiftsFetchFailure } from "../redux/slices/shiftSlice";
import { createUrlWithQueryString } from "../util/url";
import { getPaginationDataFromResponse } from "../util/pagination";

const useShiftActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getShifts = (
        employeeId: string | undefined, 
        fromDate: string | undefined, 
        toDate: string | undefined, 
        status: string | undefined, 
        type: string | undefined,
        pageIndex: number, 
        pageSize: number) => {
        dispatch(loading())

        const params = {
            employeeId: employeeId,
            fromDate: fromDate,
            toDate: toDate,
            shiftStatus: status,
            shiftType: type,
            pageNumber: pageIndex,
            pageSize: pageSize
        }

        const url = createUrlWithQueryString(apiConfig.routes.shifts, params)

        return fetchClient.get(url)
            .then(response => {
                const paginationData = getPaginationDataFromResponse(response.raw)
                dispatch(shiftsFetched({ shifts: response.data as Shift[], totalShiftCount: paginationData?.totalItemCount ?? 0}))
            })
            .catch(error => {
                console.log('getShifts error:', error)
                dispatch(shiftsFetchFailure(error))
            })
    }

    return {
        getShifts
    }
}

export default useShiftActions